import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, TagsAPI } from '@brg/api';

import { useAPIMethod } from '../useAPIMethod';
import { useAPIMethodArray } from '../useAPIMethodArray';
import { ComputedTag, computeTag } from '../../helpers/types/computed/ComputedTag';

export const useTagsByEntity = (entity: string, lang?: string) => {
    const { i18n } = useTranslation();

    return useAPIMethodArray<Tag, any>(TagsAPI.GetTagsEntities, { entities: entity }, lang ?? i18n.language);
};

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param entity
 * @param lang
 */
export const useTagsByEntityComputed = (entity: string, lang = 'en'): [ComputedTag[], boolean, string | undefined] => {
    const [r, l, e] = useAPIMethodArray<Tag, any>(TagsAPI.GetTagsEntities, { entities: entity }, lang);
    const cr = useMemo(() => r.map(computeTag), [r]);

    return [cr as ComputedTag[], l, e];
};

export const useTag = (request: any, lang = 'en', t?: number) =>
  useAPIMethod<Tag, any>(TagsAPI.GetTag, request, lang, t);
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tag, TagsAPI } from '@brg/api';

import { useAPIMethod } from '../useAPIMethod';
import { useAPIMethodArray } from '../useAPIMethodArray';
import { ComputedTag, computeTag } from '../../helpers/types/computed/ComputedTag';

export const useTagsByEntity = (entity: string, lang?: string) => {
    const { i18n } = useTranslation();

    return useAPIMethodArray<Tag, any>(TagsAPI.GetTagsEntities, { entities: entity }, lang ?? i18n.language);
};

/**
 * @deprecated Возвращаемся к первичным типам Tag, Project, Designer,... и тд, вычисляем по необходимости и месту
 * @param entity
 * @param lang
 */
export const useTagsByEntityComputed = (entity: string, lang = 'en'): [ComputedTag[], boolean, string | undefined] => {
    const [r, l, e] = useAPIMethodArray<Tag, any>(TagsAPI.GetTagsEntities, { entities: entity }, lang);
    const cr = useMemo(() => r.map(computeTag), [r]);

    return [cr as ComputedTag[], l, e];
};

export const useTag = (request: any, lang = 'en', t?: number) =>
  useAPIMethod<Tag, any>(TagsAPI.GetTag, request, lang, t);
